// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-box {
  background-color: #ccc;
  background-image: linear-gradient(#fff, #ccc);
  border: #000000 0.1rem solid;
  border-radius: 0.5em;
  box-shadow: 0.1rem 0.1rem 0.5rem 0.05rem rgba(0, 0, 0, 64);
  column-gap: 0.5rem;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  max-height: 5rem;
  padding: 0.75rem;
  position: absolute;
  width: 12em;
  z-index: 100;
}

.visibility-hidden {
  visibility: hidden;
}

.message-box .content {
	align-self: flex-start;
	flex-grow: 1;
	flex-shrink: 1;
  font-size: 1rem;
}

.message-box .close-button {
  background: none;
  border: none;
  color: #000;
}

.message-box .close-button:hover {
  color: #008aff;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/message-box/message-box.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,4BAA4B;EAC5B,oBAAoB;EACpB,0DAA0D;EAC1D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,cAAc;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".message-box {\n  background-color: #ccc;\n  background-image: linear-gradient(#fff, #ccc);\n  border: #000000 0.1rem solid;\n  border-radius: 0.5em;\n  box-shadow: 0.1rem 0.1rem 0.5rem 0.05rem rgba(0, 0, 0, 64);\n  column-gap: 0.5rem;\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  max-height: 5rem;\n  padding: 0.75rem;\n  position: absolute;\n  width: 12em;\n  z-index: 100;\n}\n\n.visibility-hidden {\n  visibility: hidden;\n}\n\n.message-box .content {\n\talign-self: flex-start;\n\tflex-grow: 1;\n\tflex-shrink: 1;\n  font-size: 1rem;\n}\n\n.message-box .close-button {\n  background: none;\n  border: none;\n  color: #000;\n}\n\n.message-box .close-button:hover {\n  color: #008aff;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
